//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { drawMarkerOnGoogleMaps } from '@/scripts/libs/google-maps'
import { MARKER_ICON_HEIGHT, MARKER_ICON_WIDTH } from '@/scripts/constants/physical-stores'
import wcs from '@/scripts/libs/wcs'
import {
  centerBingMapUsingLocation,
  drawMarkerOnBingMap,
  initializeBingMarker,
} from '@/scripts/libs/bing-maps'
import {
  NA,
  RAYBAN_STORES,
  STORE_LOCATOR_DISCOVER_MORE_ABOUT_SERVICE_NAME,
  EYE_EXAM,
} from '@/scripts/constants/store-locator'

import RbGoogleMaps from '@/elements/google-maps/google-maps.vue'

import RbBingMaps from '@/elements/bing-maps/bing-maps.vue'

const { storeLocator } = wcs.getStoreConfig()

export default {
  name: 'rb-store-locator-store-details',
  components: {
    RbGoogleMaps,
    RbBingMaps,
  },
  props: {
    selectedStore: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isChina: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bingMap: undefined,
      bingMarker: undefined,
      googleMap: undefined,
      googleMarker: undefined,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    getStoreName() {
      return this.selectedStore.storeName
    },
    getStoreAddress() {
      return this.selectedStore?.address
    },
    getStoreCity() {
      const postalCode = this.selectedStore?.postalCode
      const city = this.selectedStore?.city
      return postalCode ? `${postalCode} - ${city}` : city
    },
    getTelephoneNumber() {
      return !!this.selectedStore?.telephone && this.selectedStore.telephone !== NA
        ? this.selectedStore.telephone
        : ''
    },
    isRaybanStore() {
      return this.selectedStore?.storeType === RAYBAN_STORES
    },
    getStoreIcon() {
      return `common__icon--physical-store-${this.selectedStore.storeType}`
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    isCanFindSection() {
      return this.selectedStore?.hereYouCanFind?.length > 0
    },
    isServicesSection() {
      return this.selectedStore?.services?.length > 0
    },
    isOpeningHoursSection() {
      return (
        this.isRaybanStore &&
        Array.isArray(this.selectedStore?.weekScheduleArray) &&
        this.selectedStore?.weekScheduleArray?.length > 0
      )
    },
  },
  watch: {
    selectedStore() {
      if (this.isMobile) {
        this.drawMarkerOnMap()
      }
    },
  },
  beforeDestroy() {
    if (this.isMobile) {
      this.removeMarkerFromMap()
    }
  },
  methods: {
    getHereYouCanFindIcon(icon) {
      return icon === EYE_EXAM
        ? 'common__icon--physical-store-eye--exam'
        : 'common__icon--physical-store-' + icon
    },
    loadBingMapAndDrawMarker(map) {
      this.bingMap = map
      this.drawMarkerOnMap()
    },
    loadGoogleMapAndDrawMarker(map) {
      this.googleMap = map
      this.drawMarkerOnMap()
    },
    removeMarkerFromMap() {
      if (this.isChina) {
        !!this.bingMap && this.bingMap.entities.clear()
      } else {
        !!this.googleMarker && this.googleMarker.setMap(null)
      }
    },
    drawMarkerOnMap() {
      this.removeMarkerFromMap()

      if (this.selectedStore.latitude && this.selectedStore.longitude) {
        if (this.isChina) {
          this.bingMarker = initializeBingMarker(this.selectedStore)
          drawMarkerOnBingMap(this.bingMap, this.bingMarker)
          centerBingMapUsingLocation(this.bingMap, this.bingMarker.getLocation())
        } else {
          this.googleMarker = drawMarkerOnGoogleMaps(
            this.selectedStore,
            this.googleMap,
            MARKER_ICON_WIDTH,
            MARKER_ICON_HEIGHT,
            storeLocator.zoomLevel,
            this.selectedStore
          )
        }
      }
    },
    getServiceTranslation(name) {
      const translation = this.translation('store_locator.store_details.services.' + name)
      const storeName =
        name === STORE_LOCATOR_DISCOVER_MORE_ABOUT_SERVICE_NAME ? this.getStoreName : ''
      return `${translation} ${storeName}`
    },
    getHref(service) {
      if (service.name === 'commercialbooking') {
        const queryParams = new URLSearchParams(window.location.search)
        const bookingToolQueryParam = queryParams.get('appType') ?? undefined
        if (bookingToolQueryParam) {
          return `${service.url}&appType=${bookingToolQueryParam}`
        } else {
          return service.url
        }
      }
      return service.url
    },
  },
}
